/** Stable replace/pending keys for labor amend queue entries. */

export function getLaborQuickAddPendingKey(
  questionnaireName: string,
  queuedAtMs: number = Date.now(),
): string {
  return `labor-quick-add:${questionnaireName}:${queuedAtMs}`;
}

export function getLaborFlowsheetEditReplaceKey(observationId: string): string {
  return `labor-flowsheet-edit:${observationId}`;
}

export function getLaborStageMoveReplaceKey(observationId: string): string {
  return `labor-stage-move:${observationId}`;
}

export function getLaborMilestoneReplaceKey(observationId: string): string {
  return `labor-milestone:${observationId}`;
}

export function getLaborStageCancelReplaceKey(laborStageId: string): string {
  return `labor-stage-cancel:${laborStageId}`;
}

export function getPostpartumFlowsheetEditReplaceKey(observationId: string): string {
  return `postpartum-flowsheet-edit:${observationId}`;
}
